export enum PaymentTransactionStatus {
    Processed = 1,
    Unknown = 2,
    Error = 3,
    Reversed = 4
}
